import { createContext, useContext } from 'react';

export interface PermissionsContextType {
  isSiteAdmin: boolean;
  isTenantOwner: boolean;
  isTenantAdmin: boolean;
  isTenantMember: boolean;
  hasTenantAccess: boolean;
  isLoading: boolean;
}

export const PermissionsContext = createContext<PermissionsContextType>({
  isSiteAdmin: false,
  isTenantOwner: false,
  isTenantAdmin: false,
  isTenantMember: false,
  hasTenantAccess: false,
  isLoading: true
});

export const usePermissions = () => {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error('usePermissions must be used within a PermissionsProvider');
  }
  return context;
};
